import { createFileRoute } from "@tanstack/react-router";

import VerifyEmailPage from "@/features/auth/pages/verify-email";

interface VerifyEmailSearchParams {
  // Token arrives from the backend verification email: <appBaseUrl>/verify-email?token=...
  token?: string;
}

export const Route = createFileRoute("/(auth)/verify-email")({
  component: () => (
    <main role="main" aria-label="Verify email page" className="min-h-screen w-full">
      <VerifyEmailPage />
    </main>
  ),
  validateSearch: (search: Record<string, unknown>): VerifyEmailSearchParams => ({
    token: search.token as string | undefined,
  }),
});
